import React from 'react';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum MButtonIconState {
  Default = 'Default',
  Transparent = 'Transparent',
}

export interface MButtonIconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  'aria-label': string;
  state?: MButtonIconState;
  aIcon: Pick<AIconProps, 'icon'>;
  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
}
